import {
    createLine1,
    createLine2,
    createLine3,
    createLine4,
} from './create-lines';

export const initGlitchRandom = () => {
    const elements = Array.from(document.querySelectorAll('[data-glitch-random]'));

    elements.forEach((element) => {
        const WIDTH_BACK_OFFSET = +element.dataset.glitchRandom || 40;

        const width = element.getBoundingClientRect().width + WIDTH_BACK_OFFSET;
        const { height } = element.getBoundingClientRect();

        const glitch = document.createElement('canvas');
        const ctx = glitch.getContext('2d');

        glitch.setAttribute('width', width);
        glitch.setAttribute('height', height);

        glitch.style.position = 'absolute';
        glitch.style.top = '0';
        glitch.style.left = '0';
        glitch.style.width = `${width}px`;
        glitch.style.height = '100%';
        glitch.style.pointerEvents = 'none';

        // Две строки между 20 и 70 процентами высоты, цветом #F6F7FA, каждая в своей половине, шириной от 5% до 90% (своей половины)
        createLine1(ctx, width, height, '#F6F7FA');
        createLine2(ctx, width, height, '#F6F7FA');

        // Две строки между 20 и 70 процентами высоты, цветом #00000
        createLine3(ctx, width, height, '#000');
        createLine4(ctx, width, height, '#000');

        element.setAttribute('style', 'position: relative');
        element.appendChild(glitch);
    });
};
